





































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  SignatureSettingsAddEdit,
  deleteSignatureSettings,
  SignatureSettingslist,
  getSignatureArea,
  backToTheAccountList,
  batchSignatureudid
} from '@/api/developer/developer-private/private'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  formatTime,
  deepCopy
} from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
  interface option {
  value: string
  text: string
}

  @Component({
    name: 'DeveloperPirvateSignature'
  })
export default class extends mixins(DateOption) {
    // api data
    private params = {
      areaCode: '',
      accountUsage: '0',
      page: 1,
      pageCount: 20
    }
    private addParams = {
      id: 0,
      areaCode: 'US',
      accountUsage: 0,
      timeInterval: 0,
      limitCount: 0,
      watingTime: 0
    }
  private batchParams = {
    udid: '',
    accountId: ''
  }
    // component data
    tableLoading = false
    tableHeight: number = 500
    loadingText = ''
    // private statusMap: Map<String, String> = new Map([['签名通过', 'six'], ['苹果限制 24~72h', 'seven'], ['苹果限制 7~30d', 'seven'],['排队中', 'five']])
    private tableData: any[] = []
    private areaList: any[] = []
    private accountList: any[] = []
    private addFormVisible: boolean = false
    private selectedData: any[] = []
    private dateArray: string[] = ['', '']
    private totalCount = 0
    private config: any = {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }
  options: option[] = [
    {
      text: '所有证书',
      value: '0'
    },
    {
      text: '新用户',
      value: '1'
    },
    {
      text: '回签',
      value: '2'
    }
  ]
  // lifecycle
  async created() {
    this.getTableData()
    this.getAreaList()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    const mock: any[] = [{
      id: 1424322
    }]
    try {
      this.tableLoading = true
      let res: any = await SignatureSettingslist(this.params)
      this.tableData = res.data.dataList || []
      this.totalCount = res.data.pageInfo.totalCount
      // this.tableData = mock
    } catch (error) {
      this.$message.error(error as string)
    } finally {
      this.tableLoading = false
    }
  }
  async handleExcel() {
    let excelParams = deepCopy(this.params)
    this.loadingText = '正在拼命加载...'
    this.tableLoading = true
    try {
      let res: any = await SignatureSettingslist(
        Object.assign(excelParams, {
          page: 1,
          pageCount: 100000
        })
      )
      if (res.status.code === 0) {
        setTimeout(() => {
          this['$message'].success('导出成功!')
        }, 200)
      } else {
        this['$message'].error('导出失败!')
        return
      }
      const filterVal: string[] = [
        'accountUsage',
        'areaCode',
        'limitCount',
        'timeInterval',
        'watingTime',
        'createDate'
      ]
      const theader: string[] = [
        '用途(1代表新用户,2代表回签用户)',
        '签名地区',
        '每批次注册设备最大数量',
        '发车间隔时间（静默时间）单位：小时',
        '等待进行批量注册的时间（人为卡设备）单位：小时',
        '创建时间'

      ]
      const list = res.data.dataList
      const data = formatJson(filterVal, list)
      exportJson2Excel(theader, data)
    } catch (error) {
      this['$message'].error(error as string)
    } finally {
      this.tableLoading = false
      this.loadingText = ''
    }
  }
  async getAreaList() {
    let res: any = await getSignatureArea()
    this.areaList = res.data.dataList
  }
  deleteAccount(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteSignatureSettings({
          ids: ids
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  async addEditAccount() {
    let res: any = await SignatureSettingsAddEdit(this.addParams)
    if (res.status.code === 0) {
      this['$message'].success('提交成功!')
      this.cancelAddForm()
      this.getTableData()
    } else {
      this['$message'].error('提交失败!')
    }
  }
  handleAdd() {
    this.addFormVisible = true
  }
  handleFormClose() {
    this.cancelAddForm()
  }
  cancelAddForm() {
    this.addParams = {
      id: 0,
      areaCode: 'US',
      timeInterval: 0,
      limitCount: 0,
      watingTime: 0,
      accountUsage: 0
    }
    this.addFormVisible = false
  }
  confirmAddForm() {
    let valid = this.addParams.areaCode && this.addParams.timeInterval && this.addParams.limitCount && this.addParams.watingTime && this.addParams.accountUsage
    if (valid) {
      this.addEditAccount()
    } else {
      return this['$message'].warning('请填写完成后再提交!')
    }
  }
  setUpdate(item: any) {
    this.addParams.id = item.id
    this.addParams.areaCode = item.areaCode
    this.addParams.timeInterval = item.timeInterval
    this.addParams.limitCount = item.limitCount
    this.addParams.watingTime = item.watingTime
    this.addParams.accountUsage = item.accountUsage.toString()
    this.addFormVisible = true
  }
  setRemove(item: any) {
    let ids = item.id.toString()
    this.deleteAccount(ids)
  }
  setRemoveAll() {
    this.$confirm('确认删除?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      let res: any = await deleteSignatureSettings({ ids: this.selectIds })
      if (res.status.code === 0) {
        this['$message'].success('删除成功')
        this.getTableData()
      } else {
        this['$message'].error('删除失败')
      }
    })
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleCopy(event: any) {
    let text: string = event.target.dataset['clipboardText'] // 使用大驼峰命名法获取
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', text)
    input.select()
    try {
      var flag = document.execCommand('copy') // 执行复制
      this.$message.success('复制成功')
    } catch (err) {
      flag = false
      this.$message.warning('复制失败')
    }
    document.body.removeChild(input) // 删除元素
    return flag
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }

  crypt(str: string) {
    return str.substring(0, 3) + '●●●●' + str.substring(str.length - 3, str.length)
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
  get selectUdIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.udid)
    })
    let udids = t.join(',')
    return udids
  }
  get selectAreaCode() {
    if (this.selectedData.length < 1) {
      return 1
    }
    const firstAreaCode = this.selectedData[0].areaCode
    for (let i = 1; i < this.selectedData.length; i++) {
      if (this.selectedData[i].areaCode !== firstAreaCode) {
        return false
      }
    }
    return firstAreaCode
  }
}
